module.exports = __webpack_public_path__ + "img/ball_0.d15ab0a6.png";